// extracted by css-extract-rspack-plugin
export default {"tile":"pxkzPre8ca2a4yPy"};